module.exports = __webpack_public_path__ + "media/images/emblems/Coat_of_arms_of_Holziken-2accf70ce1fe61720bd046b44cf3bac4.svg";